import '@polymer/iron-icon/iron-icon.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
class ConnectionStateIcon extends PolymerElement {
  static get template() {
    return html`
      <style>
        :host {
          position: relative;
          height: 40px;
          margin: 0;
          width: 0px;
          opacity: 0;
          transition:
            opacity 0.3s,
            width 0.3s;
        }
        :host([visible]) {
          opacity: 1;
          width: 40px;
          margin: 0 8px;
        }
        iron-icon {
          color: var(--connection-state-icon-color, white);
          padding: 6px;
          height: inherit;
          width: inherit;
          box-sizing: border-box;
          transition: padding 0.3s;
        }
      </style>
      <iron-icon icon="[[icon]]" outline></iron-icon>
    `;
  }

  static get is() {
    return 'connection-state-icon';
  }
  static get properties() {
    return {
      error: {
        type: Object
      },
      icon: {
        type: String
      },
      offline: {
        type: Boolean,
        value: false
      },
      visible: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      }
    };
  }
  static get observers() {
    return ['stateChanged(offline, error)'];
  }
  ready() {
    super.ready();
    this.visible = false;
    this.offline = false;
    this.error = false;
  }
  stateChanged() {
    this.visible = this.offline || this.error;
    this.icon = this.error ? 'error-outline' : 'notification:sync';
  }
}
window.customElements.define(ConnectionStateIcon.is, ConnectionStateIcon);
